<template>
    <div class="bg-white px2-pc px1-mobile pb-1">
        <div class="backlink mt3-pc">
            <a layout="row" layout-align="start center" @click="$router.push({name: 'admin-settings-langs-index'})"><v-icon class="mr-1" color="grey">mdi-chevron-left</v-icon>{{$t('params.back_langs')}}</a>
        </div>
        <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb-2 mt3-pc mt1-mobile">{{isNew ? $t('params.new_lang') : $t('params.edit_lang')}}</div>

        <v-form class="mt5-pc mt3-mobile" layout="column" layout-align="center center" ref="form" v-model="formValid" @submit.prevent="save">
            <div class="width-95-mobile">
                <div class="font-weight-bold">{{$t('langs.iso')}} *</div>
                <v-select v-model="lang.id" :items="isos" item-value="iso" item-text="name" :rules="[v => !!v || $t('errors.required')]" :hint="$t('params.iso_hint')" persistent-hint></v-select>
                <div class="font-weight-bold mb-4 mt-3">{{$t('params.translations')}} *</div>
                <v-text-field v-for="l in $store.state.locales" :label="l.toUpperCase()" v-model="lang.name[l]" class="field-width" :rules="[ v => !!v || $t('errors.required') ]" :key="l"></v-text-field>
                <v-checkbox v-model="lang.is_sys" :false-value="0" :true-value="1" :label="$t('params.is_sys')"></v-checkbox>

                <div v-if="lang.is_sys && cannotBeInterface" layout="row" layout-align="start center" class="warning--text">
                    <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
                    {{$t('params.warn_lang')}}
                </div>
            </div>

            <div layout="row" layout-align="end center" class="field-width width-95-mobile">
                <v-btn depressed color="secondary" @click="save" style="text-transform: none">{{$t('_.save')}}</v-btn>
                &nbsp;{{$t('_.or')}}&nbsp;
                <router-link :to="{name: 'admin-settings-langs-index'}" class="grey--text">{{$t('_.cancel')}}</router-link>
            </div>
        </v-form>
    </div>
</template>

<script>
    import Params from '@/api/params'
    import Useful from '@/api/useful'
    import I18nMixin from '@/mixins/i18n'

    export default {
        mixins: [I18nMixin],
        data () {
            return {
                lang: {
                    id: null,
                    name: {},
                    is_sys: 0
                },
                formValid: false,
                isos: [],
                locales: []
            }
        },
        mounted () {
            if (!this.isNew) {
                this.fetch();
            }

            this.fetchParams();

            var context = require.context("@/locales/", true, /\.json$/);

            //On check quels fichiers locales on a
            context.keys().forEach((key) => {
                let path = key;
                let tb1 = path.split('./');
                let name = tb1[1];
                let tb2 = name.split('.json');
                let l = tb2[0];
                this.locales.push(l);
            });
        },
        methods: {
            fetch () {
                Params.get('langs', this.$route.params.id).then(res => {
                    this.lang = res.data;
                })
            },
            fetchParams () {
                Useful.getIsoLangs().then(res => {
                    this.isos = res.data;
                })
            },
            save () {
                if (!this.$refs.form.validate()) {
                    return;
                }

                if(this.cannotBeInterface){
                    this.lang.is_sys = 0;
                }

                if (this.isNew) {
                    Params.create('langs', this.lang).then(() => {
                        this.$store.commit('LOAD_LANGS');
                        this.$router.push({name: 'admin-settings-langs-index'});
                        this.$snotify.success(this.$t('params.lang_created'));
                    })
                } else {
                    Params.update('langs', this.lang.id, this.lang).then(() => {
                        this.$store.commit('LOAD_LANGS');
                        this.$router.push({name: 'admin-settings-langs-index'});
                        this.$snotify.success(this.$t('params.lang_edited'));
                    })
                }
            },
        },
        computed: {
            isNew () {
                return this.$route.params.id === 'new';
            },
            cannotBeInterface(){
                if(!this.lang.id){
                    return false;
                }
                if (this.locales.indexOf(this.lang.id) > -1) {
                    return false;
                }
                return true;
            }
        }
    }
</script>